import React from "react";
import { Link } from "react-router-dom";
import bottomBorder from "../../../../img/bottom-top.png";

import "./style.scss";

const Index = () => {
  return (
    <>
      <section className="frontpage-bottom-conversion-section">
        <div className="inner-frontpage-bottom-conversion-container">
          <div className="content-container">
            <div className="header-container">
              <h2 className="conversion-title">
                Prøv Leadfind gratis i 14 dager nå.
              </h2>
              <p className="conversion-description">
                Du kan opprette en konto og registrere foretaket ditt helt
                kostnadsfritt for å teste ut tjenesten i èn uke, slik at du kan
                utforske alt av funksjonaliteter og finne ut av hvor stor
                betydning det vil ha for din virksomhet.
              </p>
            </div>
            <div className="button-container">
              <Link to="/registrer">
                <button className="register-button" type="button">
                  Start gratis prøveperiode
                </button>
              </Link>
              <a href="mailto:kontakt@leadfind.no">
                <button className="contact-button" type="button">
                  Kontakt oss
                </button>
              </a>
            </div>
          </div>
        </div>
      </section>
      <img alt="Skille" className="bottom-border" src={bottomBorder} />
    </>
  );
};

export default Index;
